export const FilterLocation = Object.freeze({
    bar: "bar",
    panel: "panel"
});

export const FilterDefaults = Object.freeze({
    multiselect: [],
    dropdown: null,
    text: "",
    checkbox: false,
    calendar: null
});

export const FilterTypes = Object.freeze({
    multiselect: "multiselect",
    dropdown: "dropdown",
    text: "text",
    checkbox: "checkbox",
    calendar: "calendar"
});